export const busCompany = [
    { fa: "تعاوني 4 ميهن نور آريا پايانه جنوب", en: "Mihan Nour Aria- Company Number 4- South Terminal" },
    { fa: "تعاوني14 پارسيان پايانه جنوب", en: "Parsian- Company Number 14- South Terminal" },
    { fa: "تعاوني5 کيان سفرپاسارگاد پايانه جنوب", en: "Kian Safar Pasargad- Company Number 5- South Terminal" },
    { fa: "تعاوني 9 راه پيما پارسيان پايانه جنوب", en: "Rah Peyma Parsian- Company Number 9- South Terminal" },
    { fa: "سير و سفر ايران بوشهر", en: "Seiro Safar Iran- Boushehr" },
    { fa: "آريا سفر آسيا بوشهر", en: "Aria Safar Asia- Boushehr" },
    { fa: "همسفر چابکسواران بوشهر", en: "Hamsafar Chaboksavaran- Boushehr" },
    { fa: "رويال سفر ايرانيان بوشهر", en: "Royal Safar Iranian- Boushehr" },
    { fa: "ايران پيما (تعاوني1) بوشهر", en: "Iran Peyma Boushehr- Company Number 1" },
    { fa: "تک سفر ايرانيان بوشهر", en: "Tak Safar Iranian- Boushehr" },
    { fa: "ايران پيمان مشهد", en: "Iran Peyman- Mashhad" },
    { fa: "جوان سير ايثار(شعبه مشهد)", en: "Javan Seir Isar- Mashhad" },
    { fa: "جهانگشت مهر مشهد", en: "Jahangasht Mehr- Mashhad" },
    { fa: "مارال سير ايرانيان", en: "Maral Seir Iranian" },
    { fa: "تعاوني6 ايمن سفر ايرانيان پايانه جنوب", en: "Imen Safar Iranian- Company Number 6 - South Terminal" },
    { fa: "تعاوني 7 عدل پايانه جنوب", en: "Adl Company Number 7-  South Terminal" },
    { fa: "بينا گشت مشهد", en: "Bina Gasht Mashhad" },
    { fa: "تعاوني 4 ميهن نور آريا پايانه غرب", en: "Mihan Nour Aria- Company Number 4- West Terminal" },
    { fa: "ايمن سفر ايرانيان پايانه غرب", en: "Imen Safar Iranian- West Terminal" },
    { fa: "تعاوني 5 کيان سفر پاسارگاد پايانه غرب", en: "Kian Safar Pasargad- Company Number 5 - West Terminal" },
    { fa: "سپهرآسيا غرب", en: "Sepehr Asia- West Terminal" },
    { fa: "ديدار سير گيتي", en: "Didar Seir Giti" },
    { fa: "تعاوني 9 راه پيما پارسيان پايانه غرب", en: "Rah Peyma Parsian- Company Number 9- West Terminal" },
    { fa: "تعاوني17پيک صبا پايانه غرب", en: "Peyk Saba- Company Number 17- West Terminal" },
    { fa: "لاله سير جهان", en: "Laleh Seir Jahan" },
    { fa: "تعاوني 16 جهان گشت مهر پايانه غرب", en: "Jahan Gasht Mehr- Company Number 16- West Terminal" },
    { fa: "تعاوني 7 عدل پايانه غرب", en: "Adl - Company Number 7-  West Terminal" },
    { fa: "سلامت سفر آذربايجان", en: "Salamat Safar Azarbaijan" },
    { fa: "آسوده سفر پايانه غرب", en: "Asoudeh Safar - West Terminal" },
    { fa: "ارس پيما", en: "Aras Peyma" },
    { fa: "تعاوني 14پارسيان پايانه غرب", en: "Parsian- Company Number 14- West Terminal" },
    { fa: "ايران پيام نو", en: "Iran Payam Nouw" },
    { fa: "آذرآهو", en: "Azar Ahou" },
    { fa: "آرتا سبلان پايانه غرب", en: "Arta Sabalan- West Terminal" },
    { fa: "سيما سفر(غرب)", en: "Sima Safar- West Terminal" },
    { fa: "سفرگستر ايرانيان پايانه غرب", en: "Safar Gostar Iranian- West Terminal" },
    { fa: "عصر ايران پايانه غرب", en: "Asr Iran- West Terminal" },
    { fa: "ماهان سفر پايانه غرب", en: "Mahan Safar- West Terminal" },
    { fa: "عدل سيرايرانيان", en: "Adl Seir Iranian" },
    { fa: "سيما سفر اردبيل", en: "Sima Safar- Ardabil" },
    { fa: "عصرايرانيان نور", en: "Asr Iranian Nour" },
    { fa: "سپهر آسيا همدان", en: "Sepehr Asia- Hamedan" },
    { fa: "عدل شماره 7 ملاير", en: "Adel - Company Number 7- Malayer" },
    { fa: "پيک معتمد کرج", en: "Peyk Motamed- Karaj" },
    { fa: "شماره 7 عدل شوش", en: "Adel - Company Number 7- Shoush" },
    { fa: "بين المللي آرام سفر", en: "Beynolmelali Aram Safar" },
    { fa: "پيک صبا قم", en: "Peyk saba- Qom" },
    { fa: "عدل قم", en: "Adl- Qom" },
    { fa: "راه پيما پارسيان", en: "Rah Peyma Parsian" },
    { fa: "آسيا سفر نهاوند", en: "Asia Safar- Nahavand" },
    { fa: "ايران پيما قزوين", en: "Iran Peyma- Qazvin" },
    { fa: "14 پارسيان", en: "Parsian - Company Number 14" },
    { fa: "ايران پيمان قم", en: "Iran Peyma- Qom" },
    { fa: "ايمن سفرايرانيان قم", en: "Imen Safar Iranian- Qom" },
    { fa: "شماره يک سمنان", en: "Company Number 1- Semnan" },
    { fa: "ايران پيما", en: "Iran Peyma" },
    { fa: "ره پيما قم", en: "Rah Peyma- Qom" },
    { fa: "راه پيما پارسيان اهر", en: "Rah Peyma Parsian- Ahar" },
    { fa: "سفرسير آريا تعاوني 3 قم", en: "Safar Seir Aria- Company Number 3- Qom" },
    { fa: "سيروسفر اروميه", en: "Seiro Safar- Urmia" },
    { fa: "جهان گشت قم", en: "Jahan Gasht Mehr- Qom" },
    { fa: "رويال سفر ايرانيان کنگان", en: "Royal Safar Iranian- Kangan" },
    { fa: "آسوده سفر پارس آباد", en: "Asoudeh Safar- Pars Abad" },
    { fa: "سيروسفر قم", en: "Seiro Safar Qom" },
    { fa: "ترابر بيتا قزوين شماره 15", en: "Tarabar Bita- Company Number 15- Qazvin" },
    { fa: "آسيا سفر قم", en: "Asia Safar- Qom" },
    { fa: "همسفر چابکسواران", en: "Hamsafar Chaboksavaran " },
    { fa: "شماره يک قم", en: "Company Number 1- Qom" },
    { fa: "عصرايران الوند همدان", en: "Asr Iran Alvand- Hamedan" },
    { fa: "پيک صبا پارس آباد", en: "Peyk Saba- Pars Abad" },
    { fa: "خوي پيمان", en: "Khoy Peyman" },
    { fa: "تندرو مشگين سير (تعاوني 9)", en: "Tondro Meshgin Seir- Company Number 9" },
    { fa: "ماهان سفر ايرانيان کرج", en: "Mahan Safar Iranian- Karaj" },
    { fa: "سيروسفر", en: "Seiro Safar" },
    { fa: "مارال سير ايرانيان (تعاوني 10)", en: "Maral Seir Iranian- Company Number 10" },
    { fa: "ايران پيما ماکو", en: "Iran Peyma- Makou" },
    { fa: "همسفر اراک", en: "Hamsafar- Arak" },
    { fa: "همسفر قم", en: "Hamsafar- Qom" },
    { fa: "سيروسفر", en: "Seiro Safar" },
    { fa: "ايران خوي", en: "Iran Khoy" },
    { fa: "ترابربي تا اروميه", en: "Tarabar Bita- Urmia" },
    { fa: "رويال سفر ايرانيان", en: "Royal Safar Iranian" },
    { fa: "تعاوني 4 مرند(شريفي)", en: "(Sharifi) Company Number 4- Marand " },
    { fa: "شماره15ترابربي", en: "Tarabar Bi - Compay number 15" },
    { fa: "پيک معتمد همدان", en: "Peyk Motamed- Hamedan" },
    { fa: "گيتي نورد بجستان", en: "Giti Navard- Bajestan" },
    { fa: "ايران پيما", en: "Iran Peyma" },
    { fa: "سير و سفر ايران دشتستان", en: "Seiro Safar- Dashtestan" },
    { fa: "رويال سفر ايرانيان قزوين", en: "Royal Safar Iranian- Qazvin" },
    { fa: "تعاوني آذربايجان تبريز", en: "Azarbaijan Tabriz" },
    { fa: "اطمينان گرمسار", en: "Etminan- Garmsar" },
    { fa: "الماس گرمسار", en: "Almas- Garmsar" },
    { fa: "عدل همدان", en: "Adl- Hamedan" },
    { fa: "آسوده سفر مشکين شهر", en: "Asoudeh Safar - Meshkin Shahr" },
    { fa: "کيان سفرپاسارگاد سمنان", en: "Kian Safar Pasargad- Semnan" },
    { fa: "ايران پيمان رشت", en: "Iran Peyman- Rasht" },
    { fa: "سپر آسيا", en: "Sepehr Asia" },
    { fa: "کجاوه (آسيا سفر)", en: "Kajaveh (Asia Safar)" },
    { fa: "ميهن نور آريا اراک", en: "Mihan Nour Aria- Arak" },
    { fa: "ميلاد سفر شرق گرمسار", en: "Milad Safar Shargh- Garmsar" },
    { fa: "گيتي پيما اروميه", en: "Giti Peyma- Urmia" },
    { fa: "تعاوني 10 اردبيل", en: "Company Number 10- Ardabil" },
    { fa: "ايران پيمان کرج", en: "Iran Peyman - Karaj" },
    { fa: "ايران پيما", en: "Iran Peyma" },
    { fa: "تکسفر ايرانيان اراک", en: "Tak Safar Iranian- Arak" },
    { fa: "تعاوني 17 پيک صبا", en: "Peyk Saba- Company Number 17" },
    { fa: "تک سفر ايرانيان عسلويه", en: "Tak Safar Iranian- Asaluyeh" },
    { fa: "راه پيما پارسيان (تعاوني9)", en: "Rah Peyma Parsian- Company Number 9" },
    { fa: "سيروسفر اردبيل", en: "Seiro Safar- Ardabil" },
    { fa: "آسيا سفر همدان", en: "Asia Safar- Hamedan" },
    { fa: "خوي سفر(عصر ايران)", en: "Khoy Safar- Asr Iran" },
    { fa: "آرتا سبلان اردبيل", en: "Arta Sabalan- Ardabil" },
    { fa: "تعاوني 7 عدل کوهدشت", en: "Adl- Company Number 7- Kouhdasht" },
    { fa: "عباسي", en: "Abbasi" },
    { fa: "همسفر گنبدکاووس", en: "Hamsafar- Gonbad Kavus" },
    { fa: "ايمن سفر ايرانيان گناوه", en: "Imen Safar Iranian- Ganaveh" },
    { fa: "ميهن نورآريا زاهدان", en: "Mihan Nour Aria- Zahedan" },
    { fa: "کيان سفر پاسارگاد تويسرکان", en: "Kian Safar Pasargad- Tuyserkan" },
    { fa: "گيتي پيماي خوي (سلامت سفر آذربايجان)", en: "Giti Peyma- Khoy (Salamat Safar- Azerbaijan)" },
    { fa: "آسيا سفر عسلويه", en: "Asia Safar- Asaluyeh" },
    { fa: "رويال سفرايرانيان", en: "Royal Safar Iranian" },
    { fa: "سفر گستر ساوه", en: "Safar Gostar- Saveh" },
    { fa: "تعاوني 7 عدل پايانه شرق", en: "Adl- Company Number 7- East Terminal " },
    { fa: "ميهن نور ماکو", en: "Mihan Nour- Maku" },
    { fa: "موسسه ترابر بيتا شاهين دژ", en: "Tarabar Bita Shahin Dej" },
    { fa: "پيک صبا برداسکن", en: "Peyk Saba- Bardaskan" },
    { fa: "سفرسيرآريا دامغان", en: "Safar Seir Aria- Damghan" },
    { fa: "تعاوني 7 عدل اردبيل", en: "Adl- Company Number 7- Ardabil" },
    { fa: "فرد گلستان سلطان آباد", en: "Fard Golestan- Soltan Abad" },
    { fa: "ايران پيما اراک", en: "Iran Peyma - Arak" },
    { fa: "ترابر بي تا تبريز", en: "Tarabar Bita- Tabriz" },
    { fa: "ايران پيمان اردبيل", en: "Iran Peyman - Ardabil" },
    { fa: "آريا سفر آسيا", en: "Aria Safar Asia " },
    { fa: "گيلان تبار تعاوني 11 تبريز", en: "Gilan Tabar- Company Number 11 - Tabriz" },
    { fa: "تعاوني 4 ميهن نور آريا پايانه شرق", en: "Mihan Nour Aria - Company Number 4 - East Terminal" },
    { fa: "ميهن نور اريا تبريز تعاوني 4", en: "Mihan Nour Aria - Company Number 4 - Tabriz" },
    { fa: "تعاوني 14 پارسيان پايانه شرق", en: "Parsian - Company Number 14 - East Terminal" },
    { fa: "پيک صبا ملاير", en: "Peyk saba- Malayer" },
    { fa: "سير و سفر هاديشهر", en: "Seiro Safar- Hadishahr" },
    { fa: "کجاوه تبريز", en: "Kajaveh - Tabriz" },
    { fa: "سيروسفربروجرد", en: "Seiro Safar- Borujerd" },
    { fa: "پيک صبا خوانسار", en: "Peyk Saba - Khansar" },
    { fa: "شرکت راحت پر اسلامشهر", en: "Rahat Par Company- Islamshahr" },
    { fa: "شرکت ساربان تبريز", en: "Sareban Company - Tabriz" },
    { fa: "تک سفرشماره10 سمنان", en: "Tak Safar - Company Number 10 - Semnan" },
    { fa: "ايمن سفر ايرانيان تبريز", en: "Imen Safar Iranian - Tabriz" },
    { fa: "تعاوني 7 عدل ماکو", en: "Adl - Company Number 7- Maku" },
    { fa: "ايمن سفر ايرانيان", en: "Imen Safar Iranian" },
    { fa: "گيتي نورد تبريز", en: "Giti Navard - Tabriz" },
    { fa: "سپهرآسياي تبريز", en: "Sepehr Asia - Tabriz" },
    { fa: "ايران پيمان پايانه شرق", en: "Iran Peyman- East Terminal" },
    { fa: "پيک معتمد گنبدکاووس", en: "Peyk Motamed- Gonbad Kavus" },
    { fa: "تعاوني1 مرند(اکبري)", en: "(Akbari) Company Number 1 - Marand" },
    { fa: "پيک صبا تبريز", en: "Peyk Saba - Tabriz" },
    { fa: "اتحاد شرق گرمسار", en: "Etehad Shargh Garmsar" },
    { fa: "شرکت خوش راه تبريز", en: "Khosh Rah Company - Tabriz" },
    { fa: "تعاوني 4 (خوش سفر خوي)", en: "Khosh Safar - Company Number 4 - Khoy" },
    { fa: "تعاوني5کيان سفر پاسارگاد تبريز", en: "Kian Safar Pasargad- Company Number 5 -Tabriz" },
    { fa: "ميهن نور آريا هاديشهر", en: "Mihan Nour Aria - Hadishahr" },
    { fa: "راه پيما پارسيان تبريز", en: "Rah Peyma Parsian - Tabriz" },
    { fa: "ايران پيمان تبريز", en: "Iran Peyman - Tabriz" },
    { fa: "جهانگشت مهر تبريز", en: "Jahangasht Mehr - Tabriz" },
    { fa: "آسيا سفر تبريز", en: "Asia Safar - Tabriz" },
    { fa: "عدل غرب تبريز", en: "Adl - West Terminal- Tabriz" },
    { fa: "لوان نور تبريز", en: "Lavan Nour - Tabriz" },
    { fa: "گيتي پيما (نوبنياد سابق) تبريز", en: "Giti Peyma (Former Nobonyad)- Tabriz" },
    { fa: "ميهن پرستو تبريز", en: "Mihan Parastou - Tabriz" },
    { fa: "چهارده پارسيان تبريز", en: "Parsian- Company Number 14 - Tabriz" },
    { fa: "شماره 1 آزادشهر", en: "Company Number 1 - Azadshahr" },
    { fa: "همسفر چابکسواران", en: "Hamsafar Chaboksavaran" },
    { fa: "شب نورد مهربان", en: "Shabnavard Mehraban" },
    { fa: "ميهن نور آريا آذرشهر", en: "Mihan Nour Aria - Azarshahr" },
    { fa: "آسوده سفر سراب", en: "Asoudeh Safar- Sarab" },
    { fa: "سير و سفر(آستانه اشرفيه)", en: "Seiro Safar- Astaneh-ye Ashrafiyeh" },
    { fa: "پيک صبا گلپايگان", en: "Peyk Saba - Golpayegan" },
    { fa: "همسفر چابکسواران خوي", en: "Hamsafar Chaboksavaran - Khoy" },
    { fa: "راه پيماپارسيان", en: "Rah Peyma Parsian" },
    { fa: "ترابربي تا نهاوند", en: "Tarabar Bita - Nahavand" },
    { fa: "سفرسيرآريا سمنان", en: "Safar Seir Aria - Semnan" },
    { fa: "سعيد مهر کياشهر", en: "Saeed Mehr - Kiashahr" },
    { fa: "پيک صبا تعاوني 17 کاشمر", en: "Peyk Saba - Company Number 17- Kashmar" },
    { fa: "ترابر بي تا شماره 15 کاشمر", en: "Tarabar Bita - Company Number 15 - Kashmar" },
    { fa: "سرعين سير", en: "Sarein Seir " },
    { fa: "ميهن نور اروميه", en: "Mihan Nour - Urmia" },
    { fa: "ايران پيمان گنبدکاووس", en: "Iran Peyma - Gonbad Kavus" },
    { fa: "آريا سفر آسيا اراک", en: "Aria Safar Asia - Arak" },
    { fa: "لوان نور هاديشهر", en: "Lavan Nour - Hadishahr" },
    { fa: "شماره 7عدل بدره", en: "Adl- Company Number 7- Badreh" },
    { fa: "سيما سفر خوي", en: "Sima Safar - Khoy" },
    { fa: "لاله سير پارس آباد", en: "Laleh Seir - Pars Abad" },
    { fa: "ايران پيما گنبدکاووس", en: "Iran Peyma - Gonbad Kavus" },
    { fa: "ترابربيتا", en: "Tarabar Bita" },
    { fa: "سير و سفر جلفا", en: "Seiro Safar- Jolfa" },
    { fa: "پارسيان اراک (ت 14)", en: "Parsian - Company Number 14 - Arak" },
    { fa: "آسوده سفر اسدآباد", en: "Asoudeh Safar- Asad Abad" },
    { fa: "ايران پيمان شيروان (نماينده پيک معتمد)", en: "Iran Peyman (Peyk Motamed)- Shirvan " },
    { fa: "ترابر بيتا (موسوي) هشترود", en: "Tarabar Bita (Mousavi) - Hashtrood" },
    { fa: "کيان سفر پاسارگاد تربت جام", en: "Kian Safar Pasargad - Torbat Jam" },
    { fa: "آسان سفر مهر تربت جام", en: "Asan Safar Mehr - Torbat Jam" },
    { fa: "شماره سه سفرسيرآريا تربت جام", en: "Safar Seir Aria - Company Number 3 - Torbat Jam" },
    { fa: "پيک معتمد تربت جام", en: "Peyk Motamed- Torbat Jam" },
    { fa: "خوش مسافرت تربت جام", en: "Khosh Mosaferat- Torbat Jam" },
    { fa: "ولايت پيماي جام", en: "Velayat Peyma- Jam" },
    { fa: "پيک صبا آذر سراب", en: "Peyk Saba Azar - Sarab" },
    { fa: "ايمن سفر ايرانيان دير", en: "Imen Safar Iranian - Dayyer" },
    { fa: "سيرو سفر پايانه غرب", en: "Seiro Safar - West Terminal" },
    { fa: "ايمن سفر ايرانيان", en: "Imen Safar Iranian" },
    { fa: "ميهن نورآريا کوهدشت", en: "Mihan Nour Aria - Kuhdasht" },
    { fa: "ميهن نورآريا فرمهين", en: "Mihan Nour Aria - Farmahin" },
    { fa: "پيک معتمدسمنان", en: "Peyk Motamed- Semnan" },
    { fa: "کيان سفر پاسارگاد همدان", en: "Kian Safar Pasargad - Hamedan" },
    { fa: "سيروسفر ايران قزوين", en: "Seiro Safar Iran - Qazvin" },
    { fa: "آسيا سفير قاسملو شاهين دژ", en: "Asia Safir Ghasemlou- Shahin Dej" },
    { fa: "گيتي نوردتعاوني12 تويسرکان", en: "Giti Navard - Company Number 12- Tuyserkan" },
    { fa: "ترابر بي تا گنبدکاووس", en: "Tarabar Bita - Gonbad Kavous" },
    { fa: "ايران پيمان پايانه غرب", en: "Iran Peyman - West Terminal" },
    { fa: "آرامش خاطر گناباد", en: "Aramesh Khater- Gonabad" },
    { fa: "گيتي نورد گناباد", en: "Giti Navard- Gonabad" },
    { fa: "آسياسفر کاشمر", en: "Asia Safar - Kashmar" },
    { fa: "ماهان سفر تبريز", en: "Mahan Safar- Tabriz" },
    { fa: "جهانگشت مهر اراک", en: "Jahangasht Mehr - Arak" },
    { fa: "سفر طلايي پايانه غرب", en: "Safar Talaei - West Terminal" },
    { fa: "تعاوني 15 ترابربيتا", en: "Tarabar Bita - Company Number 15" },
    { fa: "پيک معتمد زاهدان", en: "Peyk Motamed- Zahedan" },
    { fa: "گيتي پيما زاهدان", en: "Giti Peyma - Zahedan" },
    { fa: "آرياسفر زاهدان", en: "Aria Safar- Zahedan" },
    { fa: "شماره 7عدل زاهدان", en: "Adl - Company Number 7- Zahedan" },
    { fa: "جهان گشت مهر زاهدان", en: "Jahan Gasht Mehr- Zahedan" },
    { fa: "سيروسفردرخشان زاهدان", en: "Seiro safar Derakhshan- Zahedan" },
    { fa: "تک سفرايرانيان زاهدان", en: "Tak Safar Iranian- Zahedan" },
    { fa: "ايمن سفرايرانيان شماره شش زاهدان", en: "Imen Safar Iranian - Company Number 6 - Zahedan" },
    { fa: "همسفر شمس زاهدان", en: "Hamsafar Shams - Zahedan" },
    { fa: "ايران پيمااميد زاهدان", en: "Iran Peyma Omid- Zahedan" },
    { fa: "لوان نور", en: "Lavan Nour" },
    { fa: "کيان سفر پاسارگاد", en: "Kian Safar Pasargad" },
    { fa: "ايران پيمان شرق زاهدان", en: "Iran Peyman - East Terminal- Zahedan" },
    { fa: "آسياسفر زاهدان", en: "Asia Safar- Zahedan" },
    { fa: "سير و سفر ايران گناوه", en: "Seiro Safar Iran - ganaveh" },
    { fa: "شماره 15 ترابر بي تا قوچان", en: "Tarabar Bita - Company Number 15 - Quchan" },
    { fa: "ميهن نور (تعاوني4) رفسنجان", en: "Mihan Nour - Company Number 4 - Rafsanjan" },
    { fa: "شرکت مسافربري عدل گناوه", en: "Adl Transportation Company - ganaveh" },
    { fa: "ميهن نور آريا اردبيل", en: "Mihan Nour Aria - Ardabil" },
    { fa: "شرکت سفر سير آريا اردبيل", en: "Safar Seir Aria- Ardabil" },
    { fa: "تعاوني 16 همسفرآرتا", en: "Hamsafar Arta - Company Number 16" },
    { fa: "آسيا سفر (سبلان تور) اردبيل", en: "Asia Safar (Sabalan Tour)- Ardabil" },
    { fa: "پيک صبا زاهدان", en: "Peyk Saba - Zahedan" },
    { fa: "کيان سفر پاسارگاد کوهدشت", en: "Kian Safar Pasargad - Kouhdasht" },
    { fa: "ترابر بي تا اردبيل", en: "Tarabar Bita - Ardabil" },
    { fa: "عصر ايران شبستر", en: "Asr Iran - Shabestar" },
    { fa: "ايران پيما (تند پويان)", en: "Iran Peyma (Tond Pouyan)" },
    { fa: "پيک معتمد نيشابور", en: "Peyk Motamed- Neyshabur" },
    { fa: "همسفر چابکسواران", en: "Hamsafar Chaboksavaran" },
    { fa: "شايان پيما سنقر", en: "Shayan Peyma - Songhor" },
    { fa: "قدس سنقر", en: "Ghods - Songhor" },
    { fa: "ترابر بي تا سياهکل", en: "Tarabar Bita- Siahkal" },
    { fa: "همسفر چابکسواران مشهد", en: "Hamsafar Chaboksavaran- Mashhad" },
    { fa: "ميهن نور آريا (تعاوني4) سراب", en: "Mihan Nour Aria - Company Number 4 - Sarab" },
    { fa: "تک سفر ايرانيان اروميه", en: "Tak Safar Iranian - Urmia" },
    { fa: "عصرايران", en: "Asr Iran" },
    { fa: "آسان سفر مهر سراب", en: "Asan Safar Mehr - Sarab" },
    { fa: "تعاوني15 مرند(اکبري)", en: "Akbari- Company Number 15 - Marand" },
    { fa: "جهان گشت مهر کاشمر", en: "Jahangasht Mehr - Kashmar" },
    { fa: "تک سفر ايرانيان کنگان", en: "Tak Safar Iranian - Kangan" },
    { fa: "تک سفر ايرانيان تبريز", en: "Tak Safar Iranian - Tabriz" },
    { fa: "تعاوني7 عدل قرچک", en: "Adl- Company Number 7- Qarchak" },
    { fa: "تعاوني 15 ترابر بي تا", en: "Tarabar Bita- Company Number 15" },
    { fa: "آريا سفر آسيا قم", en: "Aria Safar Asia- Qom" },
    { fa: "مارال سفر ايرانيان", en: "Maral Safar Iranian" },
    { fa: "تعاوني 7 شوشتر", en: "Shoushtar - Company Number 7" },
    { fa: "تعاوني ۵ سلماس (کيان سفرپاسارگاد)", en: "Kian Safar Pasargad - Company Number 5 - Salmas" },
    { fa: "آسوده سفر سراب", en: "Asoudeh Safar- Sarab" },
    { fa: "سعادت بوکان (تعاوني7)", en: "Sa'adat Bukan- Company Number 7" },
    { fa: "اطمينان اروميه", en: "Etminan - Urmia" },
    { fa: "آسيا سفر بوشهر", en: "Asia safar- Boushehr" },
    { fa: "ترابر بيتا شعبه پايانه قم", en: "Tarabar Bita - Qom" },
    { fa: "گيتي نورد بشرويه", en: "Giti Navard- Boshrouyeh" },
    { fa: "ديدار سير گيتي", en: "Didar Seir Giti" },
    { fa: "تعاونى شماره 15 ترمينال غرب", en: "Company Number 15 - West Terminal" },
    { fa: "تعاونى شماره 15 پايانه جنوب", en: "Company Number 15 - South Terminal" },
    { fa: "رويال سفر ايرانيان پايانه بيهقي", en: "Royal Safar Iranian - Beyhaghi Terminal" },
    { fa: "سير و سفر پايانه بيهقي", en: "Seiro Safar - Beyhaghi Terminal" },
    { fa: "رويال سفر ايرانيان پايانه صفه", en: "Royal safar Iranian - Sofeh Terminal" },
    { fa: "رويال سفر ايرانيان پايانه کاوه", en: "Royal Safar Iranian - Kaveh Terminal" },
    { fa: "سير و سفر پايانه شرق", en: "Seiro Safar - East Terminal" },
    { fa: "تعاونى شماره 15 ترمينال شرق", en: "Company Number 15 - East Terminal" },
    { fa: "رويال سفر ايرانيان", en: "Royal Safar Iranian" },
    { fa: "شرکت سير و سفر", en: "Seiro Safar" },
    { fa: "سير و سفر", en: "Seiro Safar" },
    { fa: "رويال سفر ايرانيان", en: "Royal Safar Iranian" },
    { fa: "رويال سفر ايرانيان", en: "Royal Safar Iranian" },
    { fa: "رويال سفر ايرانيان همدان", en: "Royal Safar Iranian - Hamedan" },
    { fa: "رويال سفر ايرانيان", en: "Royal Safar Iranian" },
    { fa: "تعاوني 15 بى تا کرج(تي بي تي)", en: "Bita (Ti Bi Ti) - Company Number 15 - Karaj" },
    { fa: "سير و سفر", en: "Seiro Safar" },
    { fa: "سير و سفر", en: "Seiro Safar" },
    { fa: "رويال سفر ايرانيان", en: "Royal Safar Iranian" },
    { fa: "گيتى پيما ايران", en: "Giti Peyma Iran" },
    { fa: "رويال سفر ايرانيان گرگان", en: "Royal Safar Iranian - Gorgan" },
    { fa: "رويال سفر ايرانيان", en: "Royal Safar Iranian" },
    { fa: "رويال سفر ايرانيان", en: "Royal Safar Iranian" },
    { fa: "رويال سفر ايرانيان", en: "Royal Safar Iranian" },
    { fa: "رويال سفر ايرانيان", en: "Royal Safar Iranian" },
    { fa: "سير و سفر خرم آباد", en: "Seiro Safar - Khorramabad" },
    { fa: "همسفر چابکسواران بندر عباس", en: "Hamsafar Chaboksavaran- Bandar Abbas" },
    { fa: "آسيا سفر خليج فارس", en: "Asia Safar - Khalij Fars" },
    { fa: "ترابر بي تا بندرعباس", en: "Tarabar Bita - Bandar Abbas" },
    { fa: "ترابربيتا بهارستان", en: "Tarabar Bita- Bahrestan" },
    { fa: "مهرپيما تعاوني14 پارسيان سلماس", en: "Mehr Peyma - Company Number 14 - Parsian Salmas" },
    { fa: "رويال سفر ايرانيان قايم شهر", en: "Royal Safar Iranian - Qaemshahr" },
    { fa: "لوان نور قشم", en: "Lavan Nour - Qeshm" },
    { fa: "ايمن سفر مشهد", en: "Imen Safar - Mashhad" },
    { fa: "مسافربري مولايي", en: "Molaei Transportation" },
    { fa: "تعاوني7 عدل", en: "Adl - Company Number 7" },
    { fa: "شرکت ايران پيمان", en: "Iran Peyman Company" },
    { fa: "همسفر چابکسواران انديمشک", en: "Hamsafar Chaboksavaran - Andimeshk" },
    { fa: "ماهان سفر ايرانيان پايانه جنوب", en: "Mahan Safar Iranian - South Terminal" },
    { fa: "سير و سفر بابل", en: "Seiro Safar - Babol" },
    { fa: "گيتي پيما", en: "Giti Peyma" },
    { fa: "سير و سفر گرگان", en: "Seiro Safar - Gorgan" },
    { fa: "ترابر بي تا شعبه همدان", en: "Tarabar Bita - Hamedan" },
    { fa: "رويال سفر ايرانيان پايانه غرب", en: "Royal Safar Iranian - West Terminal" },
    { fa: "سرچم آزاد اردبيل (تعاوني14 پارسيان)", en: "Sarcham-e Azad- Company Number 14 Parsian - Ardabil" },
    { fa: "لوان نور بندرعباس", en: "Lavan Nour - Bandar Abbas" },
    { fa: "پيک صبا بندرعباس", en: "Peyk Saba - Bandar Abbas" },
    { fa: "آريا سفر آسيا بندرعباس", en: "Aria Safar Asia - Bandar Abbas" },
    { fa: "ماهان سفر ايرانيان شاهين دژ", en: "Mahan Safar Iranian - Shahin Dej" },
    { fa: "آرتا سبلان بابل", en: "Arta Sabalan - Babol" },
    { fa: "ميهن نور آريا (تعاوني 4) بجنورد", en: "Mihan Nour Aria - Company Number 4 - Bojnurd" },
    { fa: "تعاوني 5 گراب (کيان سفر پاسارگاد)", en: "Kian Safar Pasargad - Company Number 5 - Garab" },
    { fa: "رويال سفر ايرانيان چالوس", en: "Royal Safar Iranian - Chalus" },
    { fa: "سيرو سفر کوچصفهان", en: "Seiro Safar - Kouchesfahan" },
    { fa: "رويال سفر ايرانيان", en: "Royal Safar Iranian" },
    { fa: "ايران پيمان", en: "Iran Peyman" },
    { fa: "ميهن نورآريا اسلامشهر", en: "Mihan Nour Aria- Islamshahr" },
    { fa: "تک سفر بندرعباس", en: "Tak Safar - Bandar Abbas" },
    { fa: "لوان نور گناوه", en: "Lavan Nour - Ganaveh" },
    { fa: "همسفر چابکسواران همدان", en: "Hamsafar Chaboksavaran- Hamedan" },
    { fa: "پيک صباسلطان آباد", en: "Peyk Saba - Soltan Abad" },
    { fa: "تعاوني 16 جهانگشت مهر ورامين", en: "Jahan Gasht Mehr - Company Number 16 - Varamin" },
    { fa: "رويال سفر ايرانيان", en: "Royal Safar Iranian" },
    { fa: "تک سفر ايرانيان بجنورد", en: "Tak Safar Iranian - Bojnurd" },
    { fa: "تعاوني7 عدل آستانه اشرفيه", en: "Adl - Company Number 7- Astaneh-ye Ashrafiyeh" },
    { fa: "آريا سفر آسيا قزوين", en: "Aria Safar Asia- Qazvin" },
    { fa: "تعاوني 7 عدل خوي", en: "Adl - Company Number 7- Khoy" },
    { fa: "شماره7عدل سوسنگرد", en: "Adl - Company Number 7- Susangerd" },
    { fa: "آريا سفر آسيا ماسال", en: "Aria Safar Asia - Masal" },
    { fa: "ايران پيما خوانسار", en: "Iran Peyma - Khansar" },
    { fa: "آسيا سفر هشترود", en: "Asia Safar- Hashtrood" },
    { fa: "سپهر آسيا", en: "Sepehr Asia" },
    { fa: "دو شرکت خوانسار پيک صبا و ايمن سفر", en: "Peyk Saba - Khansar and Imen Safar- Khansar" },
    { fa: "ايمن سفر ايرانيان خوانسار", en: "Imen Safar Iranian- Khansar" },
    { fa: "ترابرسيربيتا بوشهر", en: "Tarabar Seir Bita- Bushehr" },
    { fa: "تعاوني 2 پيک معتمد", en: "Peyk Motamed- Company Number 2" },
    { fa: "رويال سفر ايرانيان", en: "Royal Safar Iranian" },
    { fa: "جهانگشت مهر گناباد", en: "Jahan Gasht Mehr- Gonabad" },
    { fa: "اسوده سفر شعبه اردبيل", en: "Asoudeh Safar - Ardabil" },
    { fa: "رويال سفر ايرانيان", en: "Royal Safar Iranian" },
    { fa: "تعاوني 7 عدل رشت", en: "Adl - Company Number 7- Rasht" },
    { fa: "تعاوني14پارسيان", en: "Parsian - Company Number 14" },
    { fa: "تعاوني 4 ميهن نور آريا", en: "Mihan Nour Aria- Company Number 4" },
    { fa: "سيرو سفر", en: "Seiro Safar" },
    { fa: "عدل شاهين دژ", en: "Ad l- Shahin Dej" },
    { fa: "عدل بوشهر", en: "Adl - Bushehr" },
    { fa: "بين المللي نيل چشم گستر", en: "Beynolmelali Nil Cheshm Gostar" },
    { fa: "تعاوني 14 پارسيان", en: "Parsian - Company Number 14" },
    { fa: "ماهان سفر ايرانيان", en: "Mahan Safar Iranian" },
    { fa: "آرياسفر آسيا گناوه", en: "Aria Safar Asia - Ganaveh" },
    { fa: "آسيا سفر دزفول", en: "Asia Safar Dezfoul" },
    { fa: "ايران پيما", en: "Iran Peyma" },
    { fa: "رويال سفر ايرانيان", en: "Royal Safar Iranian" },
    { fa: "رويال سفر ايرانيان", en: "Royal Safar Iranian" },
    { fa: "تعاوني 9 راه پيما پارسيان", en: "Rah Peyma Parsian - Company Number 9" },
    { fa: "تعاوني 7 عدل", en: "Adl - Company Number 7" },
    { fa: "آسيا سفر خيام نيشابور", en: "Asia Safar Khayam - Neyshabur" },
    { fa: "پارسيان مشگين (تعاوني14)", en: "Parsian Meshgin- Company Number 14" },
    { fa: "ديدار سير گيتي", en: "Didar Seir Giti" },
    { fa: "پيک معتمد مشهد", en: "Peyk Motamed - Mashhad" },
    { fa: "ايران پيما اروميه(تعاوني يک)", en: "Iran Peyma- Company Number 1 - Urmia" },
    { fa: "تعاوني 7 عدل کرج", en: "Adl - Company Number 7- Karaj" },
    { fa: "سيروسفر پايانه جنوب", en: "Seiro Safar - South Terminal" },
    { fa: "ديدار سير گيتي", en: "Didar Seir Giti" },
    { fa: "پيک معتمد مشهد", en: "Peyk Motamed - Mashhad" },
    { fa: "ايران پيما اروميه(تعاوني يک)", en: "Iran Peyma- Company Number 1 - Urmia" },
    { fa: "تعاوني 7 عدل کرج", en: "Adl - Company Number 7- Karaj" },
    { fa: "سيروسفر پايانه جنوب", en: "Seiro Safar - South Terminal" },
    { fa: "ديدار سير گيتي", en: "Didar Seir Giti" },
    { fa: "پيک معتمد مشهد", en: "Peyk Motamed Mashhad" },
    { fa: "ايران پيما اروميه(تعاوني يک)", en: "Iran Peyma Urmia - Company Number 1" },
    { fa: "تعاوني 7 عدل کرج", en: "Adl - Company Number 7 - Karaj" },
    { fa: "سيروسفر پايانه جنوب", en: "Seiro Safar - South Terminal" },
    { fa: "ديدار سير گيتي", en: "Didar Seir Giti" },
    { fa: "پيک معتمد مشهد", en: "Peyk Motamed Mashhad" },
    { fa: "ايران پيما اروميه(تعاوني يک)", en: "Iran Peyma Urmia - Company Number 1" },
    { fa: "تعاوني 7 عدل کرج", en: "Adl - Company Number 7 - Karaj" },
    { fa: "سيروسفر پايانه جنوب", en: "Seiro Safar - South Terminal" },
    { fa: "ديدار سير گيتي", en: "Didar Seir Giti" },
    { fa: "پيک معتمد مشهد", en: "Peyk Motamed Mashhad" },
    { fa: "ايران پيما اروميه(تعاوني يک)", en: "Iran Peyma Urmia - Company Number 1" },
    { fa: "تعاوني 7 عدل کرج", en: "Adl - Company Number 7 - Karaj" },
    { fa: "سيروسفر پايانه جنوب", en: "Seiro Safar - South Terminal" },
    { fa: "ديدار سير گيتي", en: "Didar Seir Giti" },
    { fa: "پيک معتمد مشهد", en: "Peyk Motamed Mashhad" },
    { fa: "ايران پيما اروميه(تعاوني يک)", en: "Iran Peyma Urmia - Company Number 1" },
    { fa: "تعاوني 7 عدل کرج", en: "Adl - Company Number 7 - Karaj" },
    { fa: "سيروسفر پايانه جنوب", en: "Seiro Safar - South Terminal" },
    { fa: "ديدار سير گيتي", en: "Didar Seir Giti" },
    { fa: "پيک معتمد مشهد", en: "Peyk Motamed Mashhad" },
    { fa: "ايران پيما اروميه(تعاوني يک)", en: "Iran Peyma Urmia - Company Number 1" },
    { fa: "تعاوني 7 عدل کرج", en: "Adl - Company Number 7 - Karaj" },
    { fa: "سيروسفر پايانه جنوب", en: "Seiro Safar - South Terminal" },
    { fa: "ديدار سير گيتي", en: "Didar Seir Giti" },
    { fa: "پيک معتمد مشهد", en: "Peyk Motamed Mashhad" },
    { fa: "ايران پيما اروميه(تعاوني يک)", en: "Iran Peyma Urmia - Company Number 1" },
    { fa: "تعاوني 7 عدل کرج", en: "Adl - Company Number 7 - Karaj" },
    { fa: "سيروسفر پايانه جنوب", en: "Seiro Safar - South Terminal" },
    { fa: "ديدار سير گيتي", en: "Didar Seir Giti" },
    { fa: "پيک معتمد مشهد", en: "Peyk Motamed Mashhad" },
    { fa: "ايران پيما اروميه(تعاوني يک)", en: "Iran Peyma Urmia - Company Number 1" },
    { fa: "تعاوني 7 عدل کرج", en: "Adl - Company Number 7 - Karaj" },
    { fa: "سيروسفر پايانه جنوب", en: "Seiro Safar - South Terminal" },
    { fa: "ديدار سير گيتي", en: "Didar Seir Giti" },
    { fa: "پيک معتمد مشهد", en: "Peyk Motamed Mashhad" },
    { fa: "ايران پيما اروميه(تعاوني يک)", en: "Iran Peyma Urmia - Company Number 1" },
    { fa: "تعاوني 7 عدل کرج", en: "Adl - Company Number 7 - Karaj" },
    { fa: "سيروسفر پايانه جنوب", en: "Seiro Safar - South Terminal" },
    { fa: "ديدار سير گيتي", en: "Didar Seir Giti" },
    { fa: "پيک معتمد مشهد", en: "Peyk Motamed Mashhad" },
    { fa: "ايران پيما اروميه(تعاوني يک)", en: "Iran Peyma Urmia - Company Number 1" },
    { fa: "تعاوني 7 عدل کرج", en: "Adl - Company Number 7 - Karaj" },
    { fa: "سيروسفر پايانه جنوب", en: "Seiro Safar - South Terminal" },
    { fa: "ديدار سير گيتي", en: "Didar Seir Giti" },
    { fa: "پيک معتمد مشهد", en: "Peyk Motamed Mashhad" },
    { fa: "ايران پيما اروميه(تعاوني يک)", en: "Iran Peyma Urmia - Company Number 1" },
    { fa: "تعاوني 7 عدل کرج", en: "Adl - Company Number 7 - Karaj" },
    { fa: "سيروسفر پايانه جنوب", en: "Seiro Safar - South Terminal" },
    { fa: "ديدار سير گيتي", en: "Didar Seir Giti" },
    { fa: "پيک معتمد مشهد", en: "Peyk Motamed Mashhad" },
    { fa: "ايران پيما اروميه(تعاوني يک)", en: "Iran Peyma Urmia - Company Number 1" },
    { fa: "تعاوني 7 عدل کرج", en: "Adl - Company Number 7 - Karaj" },
    { fa: "سيروسفر پايانه جنوب", en: "Seiro Safar - South Terminal" },
    { fa: "ديدار سير گيتي", en: "Didar Seir Giti" },
    { fa: "پيک معتمد مشهد", en: "Peyk Motamed Mashhad" },
    { fa: "ايران پيما اروميه(تعاوني يک)", en: "Iran Peyma Urmia - Company Number 1" },
    { fa: "تعاوني 7 عدل کرج", en: "Adl - Company Number 7 - Karaj" },
    { fa: "سيروسفر پايانه جنوب", en: "Seiro Safar - South Terminal" },
    { fa: "ديدار سير گيتي", en: "Didar Seir Giti" },
    { fa: "پيک معتمد مشهد", en: "Peyk Motamed Mashhad" },
    { fa: "ايران پيما اروميه(تعاوني يک)", en: "Iran Peyma Urmia - Company Number 1" },
    { fa: "تعاوني 7 عدل کرج", en: "Adl - Company Number 7 - Karaj" },
    { fa: "سيروسفر پايانه جنوب", en: "Seiro Safar - South Terminal" },
    { fa: "ديدار سير گيتي", en: "Didar Seir Giti" },
    { fa: "پيک معتمد مشهد", en: "Peyk Motamed Mashhad" },
    { fa: "ايران پيما اروميه(تعاوني يک)", en: "Iran Peyma Urmia - Company Number 1" },
    { fa: "تعاوني 7 عدل کرج", en: "Adl - Company Number 7 - Karaj" },
    { fa: "سيروسفر پايانه جنوب", en: "Seiro Safar - South Terminal" },
    { fa: "ديدار سير گيتي", en: "Didar Seir Giti" },
    { fa: "پيک معتمد مشهد", en: "Peyk Motamed Mashhad" },
    { fa: "ايران پيما اروميه(تعاوني يک)", en: "Iran Peyma Urmia - Company Number 1" },
    { fa: "تعاوني 7 عدل کرج", en: "Adl - Company Number 7 - Karaj" },
    { fa: "سيروسفر پايانه جنوب", en: "Seiro Safar - South Terminal" },
    { fa: "ديدار سير گيتي", en: "Didar Seir Giti" },
    { fa: "پيک معتمد مشهد", en: "Peyk Motamed Mashhad" },
    { fa: "ايران پيما اروميه(تعاوني يک)", en: "Iran Peyma Urmia - Company Number 1" },
    { fa: "تعاوني 7 عدل کرج", en: "Adl - Company Number 7 - Karaj" },
    { fa: "سيروسفر پايانه جنوب", en: "Seiro Safar - South Terminal" },
    { fa: "ديدار سير گيتي", en: "Didar Seir Giti" },
    { fa: "پيک معتمد مشهد", en: "Peyk Motamed Mashhad" },
    { fa: "ايران پيما اروميه(تعاوني يک)", en: "Iran Peyma Urmia - Company Number 1" },
    { fa: "تعاوني 7 عدل کرج", en: "Adl - Company Number 7 - Karaj" },
    { fa: "سيروسفر پايانه جنوب", en: "Seiro Safar - South Terminal" },
    { fa: "ديدار سير گيتي", en: "Didar Seir Giti" },
    { fa: "پيک معتمد مشهد", en: "Peyk Motamed Mashhad" },
    { fa: "آسيا سفر لنگرود شفيعي نسب", en: "Asia Safar(Shafi'i Nasab)- Langrud" },
    { fa: "همسفر چابكسواران اصفهان پايانه کاوه", en: "Hamsafar Chaboksavaran- Esfahan Kaveh" },
    { fa: "همسفر چابكسواران اصفهان پايانه صفه", en: "Hamsafar Chaboksavaran- Esfahan Sofeh" }
]


// WEBPACK FOOTER //
// ./src/config/busCompany.jsx